module.exports = __webpack_public_path__ + "static/notebook-catalogo-54549b2ec04d906d4eb9ce16b605f226.webp";